








































































































































































import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconBoxArrowRight, BPopover } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    BIcon,
    BIconBoxArrowRight,
    BPopover,
    Header,
    Menu,
    NextPrevBtn,
    Footer
  }
})
export default class InfographyTips extends Vue {
  protected nxtprevInfographyTips = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail4.png",
    NextImage: "/thumbnail7.png",
    PrevLink: "/Infographie/Fondamentaux",
    NextLink: "/Infographie/EnPratique"
  };
}
